<template lang="pug">
  main.Portal
    top-title
    router-view
    bottom-footer
</template>

<script>
  import TopTitle from "@/components/topTitle";
  import BottomFooter from "@/components/bottomFooter";
  export default {
    name: "Portal",
    components: {BottomFooter, TopTitle},
  };
</script>
